import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LTProcessDataRoutingModule } from './lt-process-data-routing.module';
import { FastfetchComponent } from './components/fastfetch/fastfetch.component';
import { IntegrationProcessViewComponent } from './components/integration-process-view/integration-process-view.component';
import { LBADataswapComponent } from './components/lba-dataswap/lba-dataswap.component';

@NgModule({
  imports: [
    CommonModule,
    LTProcessDataRoutingModule,
    FastfetchComponent,
    IntegrationProcessViewComponent,
    LBADataswapComponent,
  ],
  exports: [
    FastfetchComponent,
    IntegrationProcessViewComponent,
    LBADataswapComponent,
  ],
})
export class LTProcessDataModule { }
